<div class="row mt-3 mb-3">
  <div class="col-12">
    <button (click)="adicionar()" #btnAdicionar class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy">
  <thead>
    <tr>
      <th scope="col" style="width: 26,66%">Responsável<span class="text-danger">*</span></th>
      <th scope="col" style="width: 26,66%">Data de início<span class="text-danger">*</span></th>
      <th scope="col" style="width: 26,66%">Data de término<span class="text-danger">*</span></th>
      <th scope="col" style="width: 90px;"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista">
      <td *ngIf="!item.editavel && item.id" style="width: 50%">{{item && item.responsavel ? item.responsavel.nome : ''}}</td>
      <td *ngIf="!item.editavel && item.id" style="width: 20%">{{item.data_inicio | date:'dd/MM/yyyy':'GMT'}}</td>
      <td *ngIf="!item.editavel && item.id" style="width: 20%">{{item.data_termino | date:'dd/MM/yyyy':'GMT'}}</td>
      <td *ngIf="item.editavel || !item.id" style="width: 40%">
        <div class="form-row">
          <div class="col-md-12">
            <div class="form-row">
              <div class="col-md-11">
                <p-autoComplete id="responsavel" [(ngModel)]="item.responsavel" [forceSelection]="true" [autoHighlight]="true"
                  [ngModelOptions]="{standalone: true}" [field]="responsavelAutoComplete.conversor"
                  [suggestions]="responsavelAutoComplete.lista" (completeMethod)="responsavelAutoComplete.filtrar($event)"
                  inputStyleClass="form-control form-control-md font-weight-bold" minLength="2" [style]="{ width: '100%' }">
                </p-autoComplete>
              </div>
              <div class="col-md-1">
                <button class="btn btn-outline-secondary float-left" type="button" data-toggle="modal"
                  data-target="#dialogPessoa" (click)="cadastroResponsavel(item)"
                  style="height: 36px;">
                  <i class="fa fa-user-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </td>
      <td *ngIf="item.editavel || !item.id" style="width: 20%">
        <p-calendar id="item.data_inicio" [(ngModel)]="item.data_inicio" inputStyleClass="form-control font-weight-bold" dataType="date"
          dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true"
          [style]="{ width: '100%' }" (onFocus)="globalService.calendarMascara()">
        </p-calendar>
      </td>
      <td *ngIf="item.editavel || !item.id" style="width: 20%">
        <p-calendar id="item.data_termino" [(ngModel)]="item.data_termino" inputStyleClass="form-control font-weight-bold" dataType="date"
          dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true"
          [style]="{ width: '100%' }" (onFocus)="globalService.calendarMascara()">
        </p-calendar>
      </td>
      <td class="text-right" style="min-width: 100px;">
        <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel && item.id" (click)="cancelar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel && !item.id" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="remover" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel && item.id" (click)="editar(item)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="remover(item)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>
<lib-pessoa-cadastro-dlg [login]="login" (callback)="carregarResponsavel($event)"></lib-pessoa-cadastro-dlg>
